<template>
<router-link :to="{name: 'teacherPage', params:{tid: this.teacher.id}}" class="teacher-img-link">
  <img :src="imgUrl" :alt="teacher.name" :title="teacher.name">
</router-link>

</template>

<script>
export default {
  name: `TeacherImglink`,
  props: {
    teacher: Object
  },

  computed: {
    imgUrl() {
      return this.$store.state.initialData.basepath + this.teacher.img;
    }
  }
};
</script>

<style lang="scss">
$purple: #656b85;

.teacher-img-link {
  display: inline-block;
  margin: 10px;
  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    transition: all 300ms ease;
  }

  &:hover,
  &:focus {
    text-decoration: none;
    img {
      box-shadow: 0 0 15px $purple;
    }
  }
}
</style>
